// Identity role koje koristi web za registar poslovnih subjekata.
export const Roles = {
  Bba: '1028', // JRR PL - FIA FBiH
  Legal: '1032', // JRR PL - FIA FBiH PRAVNI
  CodeBook: '1034', // JRR PL - FIA FBIH Codebook
  Statements: '1035', // JRR PL - Izvodi
}
